module.exports = __webpack_public_path__ + "img/9791187777649.770d8e1d.jpg";